import typography from '../typography';
import palette from '../palette';

export default {
  "@global": {
    html: {
      "-webkit-overflow-scrolling": "touch"
    },
    body: {
      fontFamily: typography.fontFamily,
      fontWeight: typography.fontWeightMedium,
      letterSpacing: typography.letterSpacing,
      color: palette.black
    },
    ":root": {
      "--ck-z-default": "1500"
    }
  }
};